module.exports = __webpack_public_path__ + "img/chest.27ed7d22.svg";